import { A11yModule, FocusTrap, FocusTrapFactory } from '@angular/cdk/a11y';
import { DialogRef } from '@angular/cdk/dialog';
import { BasePortalOutlet, CdkPortalOutlet, ComponentPortal, PortalModule, TemplatePortal } from '@angular/cdk/portal';

import { Component, ComponentRef, ElementRef, OnDestroy, OnInit, Renderer2, RendererFactory2, inject, viewChild } from '@angular/core';

@Component({
  selector: 'lib-default-dialog-container',
  standalone: true,
  imports: [PortalModule, A11yModule],
  templateUrl: './default-dialog-container.component.html',
  styleUrl: './default-dialog-container.component.scss',
})
export class DefaultDialogContainerComponent extends BasePortalOutlet implements OnInit, OnDestroy {
  dialogRef = inject(DialogRef);
  private rendererFactory = inject(RendererFactory2);
  private el = inject(ElementRef);
  private focusTrapFactory = inject(FocusTrapFactory);

  private focusTrap!: FocusTrap;
  readonly portalOutlet = viewChild.required(CdkPortalOutlet);
  protected componentPortal!: ComponentPortal<unknown>;
  private renderer: Renderer2;

  constructor() {
    super();
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  ngOnInit() {
    this.focusTrap = this.focusTrapFactory.create(this.el.nativeElement); // ✅ Enable focus trap
    this.focusTrap.focusInitialElement();
  }

  attachComponentPortal<T>(portal: ComponentPortal<T>): ComponentRef<T> {
    this.componentPortal = portal;

    const portalOutlet = this.portalOutlet();
    if (portalOutlet) {
      const componentRef = portalOutlet.attachComponentPortal(portal);
      this.renderer.addClass(componentRef.location.nativeElement, 'display-contents');
      return componentRef;
    }
    throw new Error('No PortalOutlet found to attach the component portal.');
  }

  attachTemplatePortal<C>(portal: TemplatePortal<C>) {
    return this.portalOutlet().attachTemplatePortal(portal);
  }

  ngOnDestroy(): void {
    this.focusTrap.destroy();
  }
}
